// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._26Bop{height:calc(81.25vh - 5.625rem);overflow-y:scroll;width:520px;width:32.5rem;color:#231815}@media(max-width:767px){._26Bop{width:100%;height:auto}}.nL8xS{width:100%;margin-top:1.5rem;margin-bottom:1.75rem}._1mE_S{margin-top:.625rem;font-size:16px;font-weight:300;line-height:26px;font-family:var(--base-font)}._132iL{margin-top:1.25rem}._1qi1A{margin-bottom:1.03125rem;font-size:16px;font-weight:400;line-height:26px;font-family:var(--base-font)}._16op3{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}._1YRXD{margin-bottom:1rem}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_26Bop",
	"banner": "nL8xS",
	"infoContent": "_1mE_S",
	"aboutThis": "_132iL",
	"aboutThisTitle": "_1qi1A",
	"highlightList": "_16op3",
	"highlightItem": "_1YRXD"
};
module.exports = exports;
